/* @flow */

import { baseFontSize } from '@braindate/ui/lib/token/typography';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    color: ({ theme }: ThemeFunction) => theme.textColor,

    fontStyle: 'italic',
    lineHeight: 19 / baseFontSize,
    textAlign: 'center',
    WebkitFontSmoothing: 'antialiased',
  },
  'root-withError': {
    color: ({ theme }: ThemeFunction) => theme.errorMessageColor,
  },
  'root-left': {
    textAlign: 'left',
  },
};
